import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "employee" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) navigate("/", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-grain">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <img
            src="/we-logo.png"
            alt="We Academy"
            className="h-10 w-10 object-contain"
          />
          <div>
            <div className="font-display text-lg font-bold">We Academy</div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#5B6371]">Finanz</div>
          </div>
        </div>
        <div className="label-eyebrow mb-2">Registrieren</div>
        <h2 className="font-display text-3xl font-semibold text-[#1F242E]">Neues Konto</h2>

        <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="register-form">
          <div>
            <label className="block text-xs font-medium mb-1.5">Name</label>
            <input
              required
              className="field"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              data-testid="register-name"
            />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5">E-Mail</label>
            <input
              type="email"
              required
              className="field"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="register-email"
            />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5">Passwort</label>
            <input
              type="password"
              required
              className="field"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="register-password"
            />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5">Rolle</label>
            <select
              className="field"
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
              data-testid="register-role"
            >
              <option value="employee">Mitarbeiter</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          {error && (
            <div className="text-sm text-[#FF6B5C] bg-[#FFF1EE] border border-[#FFD9D2] rounded-md px-3 py-2"
                 data-testid="register-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit"
            className="w-full bg-[#0AA09E] hover:bg-[#088987] text-white text-sm font-medium rounded-md px-4 py-2.5 transition-colors disabled:opacity-60"
          >
            {loading ? "Konto wird erstellt …" : "Konto erstellen"}
          </button>
        </form>
        <p className="text-xs text-[#5B6371] mt-6">
          Bereits ein Konto?{" "}
          <Link to="/login" className="text-[#0AA09E] font-medium hover:underline">Jetzt anmelden</Link>
        </p>
      </div>
    </div>
  );
}
